import ErrorFormatService from '../../services/error-format-service';
import {
  GET_ACTIVITY_LIST_DATA_SUCCESS, SAVE_ACTIVITY_LIST_DATA, SAVE_ACTIVITY_LIST_DATA_SUCCESS,
  SAVE_ACTIVITY_LIST_DATA_ERROR, DELETE_ACTIVITY_LIST_SUCCESS, SAVE_ACTIVITY_STATUS_SUCCESS,
  DELETE_ACTIVITY_COMMENT_SUCCESS, SAVE_ACTIVITY_COMMENT_SUCCESS, RESET_ACTIVITY_LIST_DATA, LOGOUT_USER_SUCCESS,
  LOGIN_USER_SUCCESS, SAVE_ACTIVITY_STATUS_LIST_SUCCESS, SAVE_ACTIVITY_STATUS_LIST_ERROR, GET_LIST_CONTACT_DATA_SUCCESS,
  GET_LIST_CONTACT_PERSON_DATA_SUCCESS, GET_LIST_CONTACT_COMPANY_DATA_SUCCESS, GET_LIST_DEAL_ASSET_DATA_SUCCESS,
  GET_LIST_CONTACT_PERSON_INTERNAL_DATA_SUCCESS, GET_LIST_ACTIVITY_DEAL_DATA_SUCCESS, RESET_FORM_ERRORS,
  SAVE_ACTIVITY_LIST_SUCCESS, SAVE_ACTIVITY_LIST_ERROR, SAVE_ACTIVITY_STATUS_LIST, SAVE_ACTIVITY_LIST,
  GET_LIST_TAG_DATA_SUCCESS,
} from '../../constants/system/actions';

const activityListReducer: Reducer = (
  state: ReducerState = {
    activityListData: null,
    commentList: null,
    formErrors: {},
    isFormSaving: false,
  },
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case GET_ACTIVITY_LIST_DATA_SUCCESS:
      if (!action.data.dealId) {
        return {
          ...state,
          activityListData: action.data,
        };
      }

      return state;
    case SAVE_ACTIVITY_LIST_DATA:
      return {
        ...state,
        formErrors: {},
        isFormSaving: true,
      };
    case SAVE_ACTIVITY_LIST_DATA_SUCCESS:
      if (action.data.activityListData && !action.data.activityListData.dealId) {
        return {
          ...state,
          activityListData: action.data.activityListData,
          formErrors: {},
          isFormSaving: false,
        };
      }

      return {
        ...state,
        formErrors: {},
        isFormSaving: false,
      };
    case SAVE_ACTIVITY_LIST_DATA_ERROR:
      if (!action.error) {
        return {
          ...state,
          isFormSaving: false,
        };
      }

      return {
        ...state,
        formErrors: ErrorFormatService.isFormError(action.error)
          ? ErrorFormatService.formatGraphQLErrors({ ...action.error })
          : ErrorFormatService.formatGraphQLMainError({ ...action.error }),
        isFormSaving: false,
      };
    case DELETE_ACTIVITY_LIST_SUCCESS:
    case SAVE_ACTIVITY_STATUS_SUCCESS:
    case SAVE_ACTIVITY_STATUS_LIST_SUCCESS:
    case SAVE_ACTIVITY_LIST_SUCCESS:
      if (action.data.activityListData && !action.data.activityListData.dealId) {
        return {
          ...state,
          activityListData: action.data.activityListData,
          isFormSaving: false,
        };
      }

      return {
        ...state,
        isFormSaving: false,
      };
    case DELETE_ACTIVITY_COMMENT_SUCCESS:
    case SAVE_ACTIVITY_COMMENT_SUCCESS:
      return {
        ...state,
        activityListData: state.activityListData ? {
          ...state.activityListData,
          activityList: state.activityListData.activityList.map((activityItem: Activity): Activity => (
            activityItem.id === action.data.activityId && action.data.updatedData ? ({
              ...activityItem,
              updatedDate: action.data.updatedData.updatedDate,
              updatedDateText: action.data.updatedData.updatedDateText,
              updatedByUserText: action.data.updatedData.updatedByUserText,
              comments: action.data.comments,
              attachments: action.data.attachments,
            }) : activityItem
          )),
        } : null,
        commentList: action.data.comments,
      };
    case SAVE_ACTIVITY_STATUS_LIST:
    case SAVE_ACTIVITY_LIST:
      return {
        ...state,
        formErrors: {},
        isFormSaving: true,
      };
    case SAVE_ACTIVITY_STATUS_LIST_ERROR:
    case SAVE_ACTIVITY_LIST_ERROR:
      return {
        ...state,
        isFormSaving: false,
      };
    case GET_LIST_CONTACT_DATA_SUCCESS:
      if (!state.activityListData) {
        return state;
      }

      return {
        ...state,
        activityListData: {
          ...state.activityListData,
          contactList: action.data,
        },
      };
    case GET_LIST_CONTACT_PERSON_DATA_SUCCESS:
      if (!state.activityListData) {
        return state;
      }

      return {
        ...state,
        activityListData: {
          ...state.activityListData,
          contactPersonList: action.data,
        },
      };
    case GET_LIST_CONTACT_COMPANY_DATA_SUCCESS:
      if (!state.activityListData) {
        return state;
      }

      return {
        ...state,
        activityListData: {
          ...state.activityListData,
          contactCompanyList: action.data,
        },
      };
    case GET_LIST_CONTACT_PERSON_INTERNAL_DATA_SUCCESS:
      if (!state.activityListData) {
        return state;
      }

      return {
        ...state,
        activityListData: {
          ...state.activityListData,
          contactPersonInternalList: action.data,
        },
      };
    case GET_LIST_ACTIVITY_DEAL_DATA_SUCCESS:
      if (!state.activityListData) {
        return state;
      }

      return {
        ...state,
        activityListData: {
          ...state.activityListData,
          dealList: action.data,
        },
      };
    case GET_LIST_DEAL_ASSET_DATA_SUCCESS:
      if (!state.activityListData) {
        return state;
      }

      return {
        ...state,
        activityListData: {
          ...state.activityListData,
          assetList: action.data,
        },
      };
    case GET_LIST_TAG_DATA_SUCCESS:
      if (!state.activityListData) {
        return state;
      }

      return {
        ...state,
        activityListData: {
          ...state.activityListData,
          tagList: action.data,
        },
      };
    case RESET_ACTIVITY_LIST_DATA:
      return {
        ...state,
        activityListData: null,
        commentList: null,
        formErrors: {},
        isFormSaving: false,
      };
    case RESET_FORM_ERRORS:
      return {
        ...state,
        formErrors: {},
      };
    case LOGIN_USER_SUCCESS:
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        activityListData: null,
        commentList: null,
        formErrors: {},
        isFormSaving: false,
      };
    default:
      return state;
  }
};

export default activityListReducer;
